import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import Link from '../Link';
import { buildImageLoaderUrl } from '../../utils/utils';

const useStyles = makeStyles()({
  root: {
    minWidth: 120,
    width: '220px',
    padding: 'inherit',
    boxShadow: '0px 5px 26px -10px rgba(0, 0, 0, 0.46)',
    margin: '15px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  pos: {
    marginBottom: 12,
  },
  categorie: {
    backgroundColor: 'white',
    borderRadius: '0.3em',
    color: '#f0a300',
    width: 'max-content',
    padding: '0 5px 0 5px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  actorImage: {
    height: '100%',
    width: 'max-content',
    margin: 'auto',
  },
  image: {
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    textAlign: 'inherit',
    height: '10em',
  },
  title: {
    textAlign: 'left',
    color: '#2C367E',
    width: '100%',
    fontSize: '1.5rem',
  },
  content: {
    padding: '10px',
  },
  date: {
    textAlign: 'right',
    color: '#2C367E',
  },
  titleDiv: {
    display: 'flex',
    alignItems: 'center',
  },
});

interface Entry {
  label?: string;
}

interface Picture {
  logo?: boolean;
  originalPicturePath?: string | null;
}

interface Actor {
  url: string;
  name: string;
  shortDescription?: string;
  entries?: Entry[];
  pictures: Picture[];
}

interface CardSliderActorProps {
  actor: Actor;
}

export default function CardSliderActor({ actor }: CardSliderActorProps) {
  const { classes } = useStyles();
  const myLoader = ({ src, width, quality }: { src: string; width: number; quality?: number }) => {
    return buildImageLoaderUrl(src, width, quality);
  };

  const mainPicture = Array.isArray(actor?.pictures) ? actor.pictures.filter((a) => (a.logo ? -1 : 1))[0] : undefined;

  return (
    <Link href={`/acteur/${actor.url}`}>
      <Card className={classes.root}>
        <CardContent>
          <div className={classes.image}>
            <div className={classes.categorie}>
              <Typography className={classes.categorie} gutterBottom>
                {actor.entries && actor.entries.length > 0 && actor.entries[0].label}
              </Typography>
            </div>
            {mainPicture && mainPicture.originalPicturePath != null && (
              <div style={{ position: 'relative', height: '130px' }}>
                <Image
                  className={classes.actorImage}
                  loader={myLoader}
                  fill
                  style={{ objectFit: 'contain' }}
                  src={mainPicture.originalPicturePath}
                  alt={actor.name}
                />
              </div>
            )}
          </div>
          <div className={classes.content}>
            <div className={classes.titleDiv}>
              <Typography className={classes.title}>{actor && actor.name}</Typography>
            </div>
            <Typography variant="body2" component="p">
              {actor && actor.shortDescription}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
